/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
(
    function (skyward, $, undefined)
    {
        skyward.userstudenttilesetting = skyward.userstudenttilesetting || {};

        var init = function (selector)
        {
            // Initialize UserStudentTileSetting editable browses
            if ($(selector).find('.widgetisenabledcheckbox').length > 0)
            {
                var element = $(selector).find('.widgetisenabledcheckbox');
                element.on('click', skyward.userstudenttilesetting.saveUserStudentTileSettings);
            }
        };

        skyward.userstudenttilesetting.saveUserStudentTileSettings = function ()
        {
            var isEnabledCheckbox = $(this);

            var accessMode = $('#accessmode').val();

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Family/UserStudentTileSetting/SaveUserStudentTileSetting" + accessMode,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        userStudentTileSettingID: isEnabledCheckbox.attr('id').split('-')[1],
                        enabled: isEnabledCheckbox[0].checked
                    },
                    success: function (returnData)
                    {
                        if (!returnData.success)
                        {
                            isEnabledCheckbox[0].checked = !isEnabledCheckbox[0].checked
                        }
                    }
                });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
